import React from "react";
import { SectionTitleWithInfo } from "../../../../components/SectionTitleWithInfo";
import { IconCardsContainer } from "../../../../components/IconCards/IconCardsContainer";
import { IconCardItem } from "../../../../components/IconCards/IconCardItem";
import { useIconsByFinance } from "../../../../utils/useIconsByFinance";
import { InfoNote } from "../../../../components/InfoNote";
import { financeTypesInfo, financeText } from "./constants";

import { useStyles } from "./styled";

export const FinanceBenefits = ({ financeType, isIslamicBanking }) => {
  const classes = useStyles();

  const icons = useIconsByFinance();
  const data = financeType ? financeTypesInfo[financeType] : [];

  const title = financeText[financeType]
    ? isIslamicBanking
      ? financeText[financeType].islamicTitle
      : financeText[financeType].title
    : "";
  return (
    <>
      <SectionTitleWithInfo title={title} />
      <IconCardsContainer>
        {data
          .map(({ iconName, ...item }) => ({ Icon: icons[iconName], ...item }))
          .map(({ key, text, islamicText, iconName, Icon }) => (
            <IconCardItem key={key} horizontal text={isIslamicBanking ? islamicText : text}>
              <Icon className={classes.icon} alt={iconName} />
            </IconCardItem>
          ))}
        <div className={classes.styleInfoNotes}>
          <InfoNote text="*Terms & conditions apply" />
        </div>
      </IconCardsContainer>
    </>
  );
};
